// import { userRoleGroups } from '@/constants/auth';
import { ISSUE_STATUSES } from '@/constants/issues';

// eslint-disable-next-line import/prefer-default-export
export function getIssueStatusNameAccordingToUserRoleGroup(userRoleGroup, issueStatus) {
  if (
    // userRoleGroup === userRoleGroups.CISO &&
    issueStatus?.trim() === ISSUE_STATUSES.FOUND
  ) {
    return ISSUE_STATUSES.OPEN;
  }
  return issueStatus?.trim().toLowerCase();
}
